import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { DASHBOARD_STAT } from "./apiRoutes";

interface UseGetDashboardCountProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDashboardCount = async (communityId: string, year: string) =>
  await axiosAuth.get(
    `${DASHBOARD_STAT(communityId)}/count?year=${year}`
  );

const useGetDashboardCount = ({
  communityId,
  year,
  queryParams,
}: UseGetDashboardCountProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owner-dashboard-count", communityId],
    queryFn: () => getDashboardCount(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetDashboardCount;
